import axios from 'axios'
import param from 'jquery-param'
import {useAppStore} from '@/stores/appStore'

// 1. Create a dedicated Axios instance
const api = axios.create({
    // Standard query parameter serializer using jquery-param
    paramsSerializer: (params) => param(params)
})

// Helper to check for absolute vs relative URLs
function getFullUrl(url) {
    if (url.startsWith('http')) return url
    
    // Fallback or read from app config / env
    const appStore = useAppStore()
    const apiEndpoint = appStore.apiEndpoint || ''
    return `${apiEndpoint}/${url}`
}

// 2. Request Interceptor: Handles URL prefixing & Header injection
api.interceptors.request.use((config) => {
    const appStore = useAppStore()
    
    const isPublicRoute = [
        'api/check-build',
        'api/auto-login',
        'api/login',
        'api/login/forgot-password'
    ].includes(config.url)
    
    // Format URL
    config.url = getFullUrl(config.url)
    
    // Token & Db-Name management
    const token = localStorage.getItem('token')
    
    if (isPublicRoute) {
        config.headers['Db-Name'] = appStore.databaseName
    } else if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
    }
    
    // Default to JSON unless sending FormData
    if (!(config.data instanceof FormData) && !config.headers['Content-Type']) {
        config.headers['Content-Type'] = 'application/json'
    }
    
    return config
})

// 3. Response Interceptor: Handles Global Errors (401, 409)
api.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error.response?.status
        
        switch (status) {
            case 401: // Unauthorized: Clear session and redirect
                if (localStorage.getItem('token')) {
                    localStorage.removeItem('token')
                    window.location = '/'
                }
                break
            
            case 409: // Conflict: Trigger Toast notification
                // If using a Toast store (Pinia), call it here cleanly
                // e.g., useToastStore().add({ body: error.response?.data?.message })
                console.warn('Conflict error:', error.response?.data?.message)
                break
        }
        
        return Promise.reject(error)
    }
)

export default api